// extracted by mini-css-extract-plugin
export default {"list":"CounterUniqueClosingDaysSetting_list__Hg3Ks","header":"CounterUniqueClosingDaysSetting_header__1LBUM"};